import React, {Component} from 'react';

import Inner from './Inner'; 

export default class Header extends Component {

    render() {
        const frontHeader = (
            <div className="header">
                <Inner>
                    <div className="headerContainer">
                        <h1>{this.props.title}</h1>
                        <h4>– Nem beregning af tidsfrister for udbud</h4>
                    </div>
                </Inner>
            </div>
        );

        const Header = (
            <div className="header">
                <Inner>
                    <div className="headerContainer">
                        <h1>{this.props.title}</h1>
                    </div>
                </Inner>
            </div>
        )

        return this.props.front ? frontHeader : Header;
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js